<template>
  <div>
  <Card>
      <Row>
        <i-col :md="18" span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="50">
            <FormItem label="用户名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入用户名" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getFileHistoryList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col :md="6" span="24">
          <Button style="float: right;" @click="addUpload" type="primary" :style="{marginBottom: '10px'}" icon="md-cloud-upload">上传</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getFileHistoryList"></page>
        </div>
     </Row>
      <Drawer
        title="上传"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="主机" prop="assets">
            <i-select v-model="formItem.assets"  multiple filterable>
              <i-option v-for="item in assetOptions" :value="item.inner_ip" :key="item.id" :label="item.inner_ip"></i-option>
            </i-select>
          </form-item>
          <form-item label="执行方式">
              <RadioGroup v-model="formItem.method" @on-change="onSelectMethod">
                <Radio label="ansible">Ansible</Radio>
                <Radio label="salt">Salt</Radio>
              </RadioGroup>
          </form-item>
          <form-item label="目标路径" prop="target_dir">
            <i-input  v-model="formItem.target_dir"></i-input>
          </form-item>
          <form-item label="选择上传文件" prop="file_upload">
            <template>
            <Upload
              type="drag"
              multiple
              ref="upload"
              :format="['docx','doc','txt', 'pdf','jpg','png','py']"
              :max-size="5000"
              :before-upload="handleUpload"
              action="">
              <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽到此次上传文件</p>
              </div>
           </Upload>
           <div>
              <ul class="file-list" v-for="(list,index) in file" :key="index">
                <li>文件名: <span style="font-size:15px;">{{ list.name }}</span> <Icon type="ios-close" size="20" style="float:right;" @click="delFileList(index)"></Icon></li>
              </ul>
            </div>
           </template>
          </form-item>
          <form-item label="描述" prop="description">
            <i-input  v-model="formItem.description"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" :loading="loading2" @click="handleUploadSubmit('formItem')">开始上传</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
// import { GetALLUsers } from '@/api/user'
import { getFileHistoryList, saveFileUpload, fileUpload } from '@/api/file'
import { getOpsCenterAllServer } from '@/api/opscenter'
import dayjs from 'dayjs'
export default {
  name: 'FileHistoryList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      assetsDisabled: true,
      file: [],
      fileUploadUrl: '',
      loading2: false,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '执行人', key: 'user', align: 'center', minWidth: 100 },
        { title: '主机', key: 'remote_host', align: 'center', minWidth: 100 },
        { title: '上传方式', key: 'method', align: 'center', minWidth: 100 },
        { title: '文件名', key: 'filename', align: 'center', minWidth: 100 },
        { title: '目标路径', key: 'target_dir', align: 'center', minWidth: 100 },
        { title: '上传／下载', key: 'file_operation', align: 'center', minWidth: 100 },
        { title: '执行时间', key: 'date', align: 'center', minWidth: 100 },
        {
          title: '结果',
          key: 'result',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            const row = params.row
            const color = row.result === '' ? 'success' : 'error'
            const text = row.result === '' ? '上传成功' : '上传失败'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        }
      ],
      tableData: [],
      user_all: [],
      assetOptions: [],
      system_users_all: [],
      system_users_sel: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        method: 'salt',
        assets: [],
        description: '',
        remote_host: [],
        remote_user: 'root',
        file_upload: [],
        target_dir: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        method: [{ required: true, message: '请选择上传方式 !', trigger: 'blur' }],
        target_dir: [{ required: true, message: '目标路径不能为空 !', trigger: 'blur' }],
        assets: [
          { required: true, message: '上传主机不能为空 !', trigger: 'change', type: 'array' }
        ],
        remote_host: [{ required: true, message: '请选择上传的主机', trigger: 'change', type: 'array' }]
      }
    }
  },
  methods: {
    getFileHistoryList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getFileHistoryList(params).then(res => {
        this.tableData = res.data
        this.tableData.map((item, index) => {
          item.date = dayjs(item.date).format('YYYY-MM-DD HH:mm:ss')
        })
        this.count = res.data.count
      })
    },
    initAssets () {
      getOpsCenterAllServer().then(res => { this.assetOptions = res.data })
    },
    delFileList (index) {
      let that = this
      that.file.splice(index, 1)
    },
    addUpload () {
      this.change = true
    },
    onSelectMethod (value) {
      if (value === 'ansible') {
        this.$Modal.warning({
          title: 'Ansible即将上线'
        })
      }
    },
    drawerClose () {
      let that = this.formItem
      that.assets = []
      that.description = ''
      that.remote_host = []
      that.file_upload = []
      that.target_dir = ''
      that.file = []
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getFileHistoryList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleUpload (file) {
      let that = this
      if (that.file.length >= 5) {
        this.$Message.info('最多只能上传2个文件')
      } else {
        that.file.push(file)
      }
      return false
    },
    handleUploadSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.file.length > 0) {
            this.loading2 = true
            // 多个文件上传
            this.formItem.file_upload = this.file
            this.formItem.remote_host = this.formItem.assets.join(',')
            this.changeLoadingShow = true
            let formData = new FormData()
            // 多个文件上传
            for (var i = 0; i < this.file.length; i++) {
              formData.append('file_upload', this.file[i])
            }
            formData.append('remote_host', this.formItem.remote_host)
            formData.append('method', this.formItem.method)
            formData.append('description', this.formItem.description)
            formData.append('remote_user', this.formItem.remote_user)
            formData.append('target_dir', this.formItem.target_dir)
            // 先调用 saltapi 把文件上传到 salt master , 成功后再调用 opscenter 保存历史记录
            fileUpload(formData).then(res => {
              if (res.data.code === 200) {
                saveFileUpload(formData).then(res => {
                  if (res.data.id > 0) {
                    this.assets = []
                    this.description = ''
                    this.remote_host = []
                    this.file_upload = []
                    this.target_dir = ''
                    this.file = []
                    this.loading2 = false
                    this.getFileHistoryList()
                  } else {
                    // this.$Notice.error({title: res.data})
                    this.$Message.error(res.data.msg)
                  }
                }).catch(res => {
                  console.log(res.response)
                  this.$Notice.error({
                    title: '操作失败！ 错误状态码:' + res.request.status,
                    desc: res.request.responseText
                  })
                })
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            that.$Message.error('请至少上传一个文件')
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.getFileHistoryList()
    this.initAssets()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
